import { lazy } from 'react';

export default lazy(
  () => import(/* webpackChunkName: 'quote_part_viewer' */ './QuotePartViewer'),
);
